import type { MouseEvent } from 'react';
import styles from './InfoTip.module.css';

/**
 * InfoTip — an (i) icon that shows `message` in a tooltip immediately on hover or keyboard
 * focus (the native `title` tooltip waits about a second and is easy to miss). Mirrors
 * Flutter's ToolTipWithInfoIconWidget. Safe to place inside a button: it stops the click
 * from reaching the button, so tapping the icon doesn't trigger the button's action.
 */
export function InfoTip({ message, size = 14 }: { message: string; size?: number }) {
  const stop = (e: MouseEvent) => e.stopPropagation();
  return (
    <span
      className={styles.tip}
      tabIndex={0}
      role="img"
      aria-label={message}
      onClick={(e) => { e.preventDefault(); stop(e); }}
    >
      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
        <circle cx="10" cy="10" r="7.5" />
        <path d="M10 9v5M10 6.2v.1" />
      </svg>
      <span className={styles.bubble} role="tooltip">{message}</span>
    </span>
  );
}
